import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames'

type PaginationProps = {
  onPageChange: (page: number) => void;
  pageCount: number;
  pageNumber: number;
};

function Pagination({onPageChange, pageNumber, pageCount}: PaginationProps) {
  return (
    <div className={'mt-4 flex items-center justify-end gap-2'}>
      <FontAwesomeIcon
        data-test-id={'prev'}
        icon={faChevronLeft}
        className={classNames({
          'cursor-default': pageNumber === 1,
          'cursor-pointer': pageNumber !==1,
          'opacity-100': pageNumber !==1,
          'opacity-50': pageNumber ===1,
        })}
        onClick={e => {
          if (pageNumber === 1) {
            return;
          }
          onPageChange(pageNumber - 1);
        }}
      />
      <span data-test-id={'current-page'}>{pageNumber}</span>
      <span>/</span>
      <span data-test-id={'number-of-page'}>{pageCount}</span>
      <FontAwesomeIcon
        data-test-id={'next'}
        icon={faChevronRight}
        className={classNames({
          'cursor-default': pageNumber >= pageCount,
          'cursor-pointer': pageNumber < pageCount,
          'opacity-50': pageNumber >= pageCount,
          'opacity-100': pageNumber < pageCount,
        })}
        onClick={e => {
          if (pageNumber >= pageCount) {
            return;
          }
          onPageChange(pageNumber + 1);
        }}
      />
    </div>
  );
}

export default Pagination;
